import AbstractProvider from '../App/AbstractProvider';
import Localisation from './Localisation';
import {IStoreEvents} from '../../@interfaces/services/StoreEvents/IStoreEvents';
import {LOCALE_SET_FALLBACK_LOCALE, LOCALE_SET_LOCALE, LOCALE_SET_LOCALISATIONS} from '../../_redux/locale/constants';

export default class LocalisationProvider extends AbstractProvider {
	async boot() {
		this.subscribeToStoreEvents();

		await this.service.boot();
	}

	async loading() {
		if (!Object.keys(this.service.getMessages()).length) {
			await this.service.loadMessages();
		}
	}

	protected subscribeToStoreEvents() {
		const dispatcher = this.getStoredService<IStoreEvents>('store-events');

		dispatcher.listen(LOCALE_SET_LOCALISATIONS, (e, payload) => {
			this.service.setMessages(payload.action.payload);
		});

		dispatcher.listen(LOCALE_SET_LOCALE, (e, payload) => {
			this.service.setLocale(payload.action.payload);
		});

		dispatcher.listen(LOCALE_SET_FALLBACK_LOCALE, (e, payload) => {
			this.service.setFallbackLocale(payload.action.payload);
		});
	}

	protected get service(): Localisation {
		return this.getStoredService('trans') as Localisation;
	}
}
